import React, { FC } from 'react'
import { Box, FormLabel, Tooltip } from 'front-end/src/components'
import { FormLabelProps } from '@chakra-ui/react'
import { css } from '@emotion/react'

type FormLabelIconProps = FormLabelProps & {
  icon: React.ReactElement | null
  tooltipText?: string
}

/**
 * Different FormLabel which will be used so far in Events to accommodate Icon components
 * @param props FormLabel props
 * @returns
 */
const FormLabelIcon: FC<FormLabelIconProps> = ({
  icon,
  tooltipText,
  ...rest
}) => {
  const iconEl = icon ? icon : <Box boxSize="18px" />

  return (
    <FormLabel
      pr="16px"
      m={0}
      h="40px"
      display="flex"
      alignItems="center"
      css={css`
        .Icon {
          font-size: 18px;
          svg {
            min-width: 18px;
            height: 18px;
          }
        }
      `}
      {...rest}
    >
      {tooltipText ? <Tooltip text={tooltipText}>{iconEl}</Tooltip> : iconEl}
    </FormLabel>
  )
}

export { FormLabelIcon }
